export default __webpack_public_path__ + "static/media/ArrowRight.0657fed2.svg";